export default __webpack_public_path__ + "static/media/1_9.788ff574.png";